import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  Select,
  Col,
  Row,
  Popconfirm,
  Space,
  message as AntdAlert,
  Spin,
} from "antd";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/delete-icon.svg";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as CrossIcon } from "../../../assets/crossIcon.svg";
import DragDropIcon from "../../../assets/dragdropicon.png";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import axios from "axios";
import { errorHandler } from "../../../components/unauthorizeHandler";
import { baseURL } from "../../../globalUtils/axiosConfig";

const { Option } = Select;

const DragHandle = sortableHandle(() => (
  <img alt="" height={20} width={20} src={DragDropIcon} />
));

const AddFieldsComponent = ({
  inputFields,
  setInputFields,
  createField,
  deleteField,
  updateField,
  onEditClick,
  createOption,
  updateOption,
  deleteOption,
  onEditClickOption,
  canUpdate,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteLocally = (item) => {
    const filteredInputs = inputFields.filter((el) => el.id !== item.id);
    setInputFields(filteredInputs);
  };

  const handleCancel = ({ index, name }) => {
    let fields = [...inputFields];
    fields[index].isEdit = false;
    fields[index].name = name;
    setInputFields(fields);
  };

  const handleDeleteOtionLocally = (optionItem) => {
    const { parentId, id } = optionItem;

    const inputItem = inputFields.filter((el) => el.id === parentId)[0];

    const updatedOptions = inputItem.options.filter((el) => el.id !== id);

    const final = inputFields.map((el) =>
      el.id === parentId ? { ...el, options: updatedOptions } : el
    );
    setInputFields(final);
  };

  const handleCancelOtion = (optionItem) => {
    let fields = [...inputFields];

    const { parentIndex, index, name } = optionItem;
    fields[parentIndex].options[index].isEdit = false;
    fields[parentIndex].options[index].isEdit = false;
    fields[parentIndex].options[index].name = name;
    setInputFields([...fields]);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      setLoading(true);
      const newData = arrayMoveImmutable(
        inputFields.slice(),
        oldIndex,
        newIndex
      ).filter((el) => !!el);

      // Update the local state with the new order
      setInputFields(newData);
      setLoading(false);
    }
  };

  const handleTypes = (el) => {
    const handleChange = (value, index) => {
      let fields = [...inputFields];
      fields[index] = {
        field_type: value,
        name: "",
        isEdit: true,
        isLocal: true,
        id: `field_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`,
        options: [],
      };
      setInputFields(fields);
    };

    switch (el.field_type) {
      case "text_field":
        return <Input value={el.name} />;
      case "date_field":
        return <Input value={el.name} />;
      case "choose":
        return (
          <Select
            placeholder="Select Field Type"
            style={{
              width: 220,
            }}
            disabled={!canUpdate}
            onChange={(e) => handleChange(e, el.index)}
          >
            <Option value="date_field">Date Field</Option>
            <Option value="select_field">Selector Field (Dropdown)</Option>
            <Option value="text_field">Text Field</Option>
          </Select>
        );

      default:
        break;
    }
  };

  const addChooseField = () => {
    const newField = {
      id: `field_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      name: "",
      field_type: "choose",
      isEdit: true,
      options: []
    };
    setInputFields([...inputFields, newField]);
  };

  const addOption = (inputId) => {
    const inputObj = inputFields.filter((el) => el.id === inputId)[0];
    let newOption = {
      name: "",
      isEdit: true,
      isLocal: true,
      id: `option_${Date.now()}_${inputId}_${Math.random().toString(36).substr(2, 9)}`,
    };
    let updated = {
      ...inputObj,
      options: [...inputObj.options, { ...newOption }],
    };

    let finalInputs = inputFields.map((el) =>
      el.id === inputId ? { ...el, ...updated } : el
    );

    setInputFields(finalInputs);
  };

  const RenderOptions = ({ ele, parentId, parentIndex, index }) => {
    let { isLocal, isEdit, name, id } = ele;
    const [localName, setLocalName] = useState(name);
    const inputRef = React.useRef(null);

    // Focus the input when it becomes editable
    React.useEffect(() => {
      if (isEdit && inputRef.current) {
        inputRef.current.focus();
      }
    }, [isEdit]);

    const handleSave = () => {
      if (!localName?.trim()) {
        return;
      }
      
      // Call the appropriate action (create or update)
      // The state will be updated through the parent component's state management
      if (isLocal) {
        createOption({ ...ele, parentId, name: localName.trim() });
      } else {
        updateOption({ ...ele, name: localName.trim() });
      }
    };

    const handleCancel = () => {
      // Revert to the original name if the user clicks cancel
      setLocalName(name);
      
      // If this was a new option being created, remove it
      if (isLocal) {
        handleDeleteOtionLocally({ ...ele, parentId });
      } else {
        // Just exit edit mode for existing options
        const updatedInputFields = [...inputFields];
        if (updatedInputFields[parentIndex]?.options) {
          const optionIndex = updatedInputFields[parentIndex].options.findIndex(opt => opt.id === id);
          if (optionIndex !== -1) {
            updatedInputFields[parentIndex].options[optionIndex] = {
              ...updatedInputFields[parentIndex].options[optionIndex],
              isEdit: false
            };
            setInputFields(updatedInputFields);
          }
        }
      }
    };

    return (
      <Row
        align="bottom"
        justify="space-between"
        style={{ width: "100%" }}
        key={index + name}
      >
        <Col span={8} style={{ marginLeft: "40px" }}>
          <label>{`OPTION ${index + 1} NAME`}</label>
          {isEdit ? (
            <Input
              ref={inputRef}
              placeholder={`Insert Option ${index + 1} Name`}
              value={localName}
              disabled={!canUpdate}
              onChange={(e) => setLocalName(e.target.value)}
              onBlur={(e) => {
                // Prevent blur from triggering if clicking on the save/cancel buttons
                if (!e.relatedTarget || 
                    (!e.relatedTarget.closest('.option-action-buttons') && 
                     !e.relatedTarget.closest('.ant-popover'))) {
                  e.preventDefault();
                  e.stopPropagation();
                  inputRef.current?.focus();
                }
              }}
            />
          ) : (
            <Input className="border-less-input" readOnly value={name} />
          )}
        </Col>
        {canUpdate && (
          <>
            <Col className="option-action-buttons">
              {isEdit ? (
                <Space size={15} align="baseline">
                  <SaveIcon
                    width={18}
                    height={18}
                    fill="#f25003"
                    onClick={handleSave}
                    style={{ cursor: 'pointer' }}
                  />
                  <CrossIcon 
                    width={18} 
                    height={18} 
                    fill="#f25003" 
                    onClick={handleCancel}
                    style={{ cursor: 'pointer' }}
                  />
                </Space>
              ) : (
                <Space size={15} align="baseline">
                  <EditIcon
                    width={18}
                    height={18}
                    fill="#f25003"
                    onClick={() => onEditClickOption(ele)}
                  />
                  <Popconfirm
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                    title="Are you sure you want to delete?"
                    placement="topRight"
                    onConfirm={() => deleteOption({ 
                      ...ele, 
                      template_field_id: parentId,
                      id: ele.id 
                    })}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteIcon 
                      width={18} 
                      height={18} 
                      fill="#f25003" 
                      style={{ cursor: 'pointer' }}
                    />
                  </Popconfirm>
                </Space>
              )}
            </Col>
            <Col span={1}></Col>
          </>
        )}
      </Row>
    );
  };

  const RenderInputs = ({ ele, index }) => {
    const { field_type = 'text_field', isLocal, isEdit, name, id, options } = ele;
    const [localName, setLocalName] = useState(name || '');

    // Default to text_field if field_type is undefined
    const safeFieldType = field_type || 'text_field';
    
    let label =
      safeFieldType === "select_field"
        ? "Selector Field Name"
        : safeFieldType.split("_").join(" ") + " Name";

    let placeholder = `Insert ${
      safeFieldType === "text_field"
        ? "Text"
        : safeFieldType === "date_field"
        ? "Date"
        : "Selector"
    } Field Name`;

    let showOption = field_type === "select_field" && canUpdate;

    return (
      <>
        <Row
          align="bottom"
          justify="space-between"
          className="field-row"
          key={index}
        >
          <Col span={12}>
            <label>{label}</label>
            {isEdit ? (
              <Input
                placeholder={placeholder}
                value={localName}
                disabled={!canUpdate}
                onChange={(e) => {
                  const { value } = e.target;
                  setLocalName(value);
                  inputFields[index].name = value;
                  setInputFields(inputFields);
                }}
              />
            ) : (
              <Input className="border-less-input" readOnly value={name} />
            )}
          </Col>
          {canUpdate && (
            <>
              <Col>
                {isEdit ? (
                  <Space size={15} align="baseline">
                    <SaveIcon
                      width={18}
                      height={18}
                      fill="#f25003"
                      onClick={() => {
                        if (localName?.trim()) {
                          if (isLocal) {
                            createField({ ...ele, name: localName });
                          } else {
                            updateField({ ...ele, name: localName });
                          }
                        } else {
                          AntdAlert.error("Field name cannot be empty!");
                        }
                      }}
                    />
                    <Popconfirm
                      getPopupContainer={() =>
                        document.getElementsByClassName(
                          "ant-layout-content layout-content site-layout-background custom-textarea"
                        )[0]
                      }
                      title="Are you sure you want to cancel?"
                      placement="topRight"
                      onConfirm={() =>
                        !isLocal
                          ? handleCancel({ ...ele })
                          : handleDeleteLocally(ele)
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <CrossIcon width={18} height={18} fill="#f25003" />
                    </Popconfirm>
                  </Space>
                ) : (
                  <Space size={15} align="baseline">
                    <EditIcon
                      width={18}
                      height={18}
                      fill="#f25003"
                      onClick={() => onEditClick(ele)}
                    />
                    <Popconfirm
                      getPopupContainer={() =>
                        document.getElementsByClassName(
                          "ant-layout-content layout-content site-layout-background custom-textarea"
                        )[0]
                      }
                      title="Are you sure you want to delete?"
                      placement="topRight"
                      onConfirm={() => deleteField(ele)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteIcon width={18} height={18} fill="#f25003" />
                    </Popconfirm>
                  </Space>
                )}
              </Col>
              <Col span={3}>{!ele?.isLocal && <DragHandle />}</Col>
            </>
          )}
        </Row>
        {field_type === "select_field" && (
          <Row className="select-options-parent-row" key={`${index}:${id}`}>
            <Col span={24}>
              <Row className="item-dev" gutter={[0, 5]}>
                {options.map((el, i) => {
                  return (
                    <Col
                      style={{ height: "50px", margin: "10px" }}
                      span={24}
                      key={`${i}:asd${index}`}
                    >
                      <Row gutter={[0, 60]}>
                        <RenderOptions
                          ele={el}
                          parentId={id}
                          parentIndex={index}
                          index={i}
                        />
                      </Row>
                    </Col>
                  );
                })}
                {showOption && (
                  <Col span={20}>
                    <Button
                      onClick={() => addOption(id)}
                      icon={<PlusOutlined />}
                      className="add-option-btn"
                      size="middle"
                    >
                      Option
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        )}
      </>
    );
  };

  const SortableItem = sortableElement(({ value, ...rest }) => {
    const { index } = value;
    return (
      <Col span={24} {...rest} key={rest.id}>
        <RenderInputs ele={{ ...value }} index={index} />
        <hr />
      </Col>
    );
  });

  const SortableContainer = sortableContainer(({ children }) => {
    return <div style={{ width: "100%" }}>{children}</div>;
  });

  return (
    <Spin spinning={loading}>
      <SortableContainer onSortEnd={onSortEnd} useDragHandle>
        <Row gutter={[20, 10]} className="doc-template-parent-div">
          {inputFields.map((el, i) => {
            const { field_type } = el;
            if (field_type !== "choose") {
              return (
                <SortableItem
                  key={`item-${el.id}`}
                  index={i}
                  value={{ ...el, index: i }}
                />
              );
            } else {
              return (
                <Col span={24} className="choose-col" key={900}>
                  <div className="choose-select-div">
                    <label>Field Type</label>
                    <Row>{handleTypes({ ...el, index: i })}</Row>
                  </div>
                  <hr />
                </Col>
              );
            }
          })}
          {canUpdate && (
            <Col span={24} key={6789}>
              <Button
                onClick={addChooseField}
                icon={<PlusOutlined />}
                className="add-field-btn"
              >
                FIELD
              </Button>
            </Col>
          )}
        </Row>
      </SortableContainer>
    </Spin>
  );
};

export default AddFieldsComponent;
